import Link from 'next/link';

const Footer = () => {
    return ( 
    <footer>
        <div className="subscribe-wrapper padding-top padding-bottom">
            <div className="container">
                <div className="subscribe-info">
                    <h3>Inscrit toi à notre newsletter</h3>
                    <p>Pour être au courant des updates, conseils et bons plans.</p>
                </div>
                <div className="input-group subscribe-box">
                    <input type="email" placeholder="Email address" className="form-control"/>
                    <span className="input-group-btn">
                        <button className="btn" type="submit">{`S'inscrire`}</button>
                    </span>
                </div>
            </div>
        </div>
        <div className="container ft-bottom-container">
            <p>Copyright © 2022 <strong>Residen</strong>. All rights reserved.   <Link  href="/terms-conditions"><a> <strong>Terms & Conditions</strong></a></Link> <Link  href="/privacy-policy"><a> <strong>Privacy Policy</strong></a></Link> </p>
            <div className="ft-links">
                <Link  href="https://www.facebook.com/residen.io"><a target="_blank"><i className="bi bi-facebook"></i></a></Link>
                {/* <Link href="/"><a><i className="bi bi-twitter"></i></a></Link> */}
                <Link href="https://www.instagram.com/residen.io/?hl=fr"><a target="_blank"><i className="bi bi-instagram"></i></a></Link>
                <Link href="https://www.linkedin.com/company/residen/?viewAsMember=true"><a target="_blank"><i className="bi bi-linkedin"></i></a></Link>
            </div>
        </div> 
    </footer>
    );
}
 
export default Footer;
